import { useEffect, useState } from 'react';
import { api } from '../api.js';

const VALUES = ['GLÄDJE', 'GEMENSKAP', 'FOSTRAN', 'IDEALITET', 'KUNSKAP'];
const LAST_TEAM = 'sif-bingo-team';

function rememberedTeam() {
  try { return localStorage.getItem(LAST_TEAM) || ''; } catch { return ''; }
}

export function Login({ onLogin }) {
  const [role, setRole] = useState('ledare');
  const [teams, setTeams] = useState(null);     // null = still loading
  const [teamId, setTeamId] = useState(rememberedTeam);
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get('/auth/teams')
      .then(r => {
        setTeams(r.teams);
        setTeamId(id => (r.teams.some(t => t.id === id) ? id : ''));
      })
      .catch(err => { setTeams([]); setError(err.message); });
  }, []);

  const pickRole = r => { setRole(r); setError(''); setPassword(''); };

  const submit = async e => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      if (role === 'admin') {
        await onLogin({ role, name: name.trim(), password });
      } else {
        try { localStorage.setItem(LAST_TEAM, teamId); } catch { /* private mode */ }
        await onLogin({ role, teamId, password });
      }
    } catch (err) {
      setError(err.message || 'Kunde inte logga in.');
      setBusy(false);
    }
  };

  const ready = role === 'admin' ? name.trim() && password : teamId && password;

  return (
    <div className="login">
      <div className="login-brand">
        <div className="emblem"><img src="/sif-logo.png" alt="SIF" /></div>
        <h1>Sandareds IF<br />Bingolotteri</h1>
        <p>Administrera lagens lottförsäljning, följ intjäning och lagkassor – säsong för säsong.</p>
        <div className="values">
          {VALUES.flatMap((v, i) => (i ? [<span key={'d' + i}>·</span>, <span key={v}>{v}</span>] : [<span key={v}>{v}</span>]))}
        </div>
      </div>

      <div className="login-form">
        <form onSubmit={submit}>
          <h2>Logga in</h2>
          <p>Välkommen tillbaka.</p>
          <div className="seg">
            <button type="button" className={role === 'ledare' ? 'on' : ''} onClick={() => pickRole('ledare')}>Ledare</button>
            <button type="button" className={role === 'admin' ? 'on' : ''} onClick={() => pickRole('admin')}>Admin</button>
          </div>
          <div className="field" style={{ marginBottom: 14 }}>
            {role === 'admin' ? (
              <>
                <label className="label" htmlFor="login-name">Användarnamn</label>
                <input
                  id="login-name" className="input" autoComplete="username"
                  value={name} onChange={e => setName(e.target.value)}
                />
              </>
            ) : (
              <>
                <label className="label" htmlFor="login-team">Lag</label>
                <select
                  id="login-team" className="input" value={teamId}
                  onChange={e => setTeamId(e.target.value)} disabled={!teams || !teams.length}
                >
                  <option value="" disabled>
                    {!teams ? 'Hämtar lag…' : teams.length ? 'Välj ditt lag' : 'Inga lag upplagda ännu'}
                  </option>
                  {(teams || []).map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                </select>
              </>
            )}
          </div>
          <div style={{ marginBottom: 8 }}>
            <label className="label" htmlFor="login-pass">Lösenord</label>
            <input
              id="login-pass" type="password" className="input" autoComplete="current-password"
              value={password} onChange={e => setPassword(e.target.value)}
            />
          </div>
          {error && <div className="alert">{error}</div>}
          <button type="submit" className="btn btn-block" style={{ marginTop: 16, padding: 13, fontSize: 15.5 }} disabled={busy || !ready}>
            {busy ? 'Loggar in…' : 'Logga in'}
          </button>
        </form>
      </div>
    </div>
  );
}
